import React, { useEffect, useState } from "react";
import GuideSection from "../components/guide/GuideSection";
import { salesGuide } from "../components/guide/guideContent";
import { formatPrice } from "../utils/formatPrice";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../redux/actions/CartActions";
import pricing from "../assets/data/pricing.json";
import { Col, Image, Row } from "react-bootstrap";
import serviceCode from "../assets/data/serviceCode.json";
import { addToServiceList } from "../redux/actions/ServiceListActions";

function PlatformSale() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleButtonClick = async () => {
    await dispatch(
      addToCart({
        platformSale: {
          periodicity: selectedPlan,
          amount:
            selectedPlan === "annuel"
              ? pricing.platformSale.annuel
              : pricing.platformSale.mensuel,
        },
      }),
    );
    await dispatch(
      addToServiceList({
        code: serviceCode.platformSale,
        billing: selectedPlan === "annuel" ? "yearly" : "monthly",
      }),
    );
    navigate("/platform-juridique");
  };

  const handleSkipClick = () => {
    navigate("/platform-juridique");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        <div
          className="container my-4 text-center"
          style={{ maxWidth: "800px" }}
        >
          <h4 className="text-2xl font-semibold">
            Suivez vos <span style={{ color: "#FF5500" }}>clients</span> & vos{" "}
            via
            <span style={{ color: "#FF5500" }}> PlatformClient</span>
          </h4>
        </div>

        <div className="container mt-4">
          <Row>
            <Col md={4} className="mb-3">
              <Image
                src="/images/ventes/client_follow.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Suivi client
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <Image
                src="/images/ventes/client_tracking.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Relances clients
              </div>
            </Col>

            {/* <Col md={3} className="mb-3">
                <Image
                  src="/images/ventes/meeting_notes.webp"
                  alt="About"
                  fluid
                  className="d-block mx-auto"
                  height={200}
                  width={200}
                  style={{ borderRadius: 16 }}
                />
                <div style={{ fontSize: "16px", fontWeight: "500" }}>
                  Mémo de réunion (transcription)
                </div>
              </Col> */}

            <Col md={4} className="mb-3">
              <Image
                src="/images/ventes/client_contact.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Contacts Clients
              </div>
            </Col>
          </Row>
        </div>

        <div className="container text-center">
          <h5 className="mb-3">Choisissez votre abonnement</h5>
          <div className="d-flex justify-content-center gap-4">
            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="mensuel"
                checked={selectedPlan === "mensuel"}
                onChange={() => setSelectedPlan("mensuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformSale.mensuel)} / mois (abonnement
                mensuel)
              </span>
            </label>

            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="annuel"
                checked={selectedPlan === "annuel"}
                onChange={() => setSelectedPlan("annuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformSale.annuel)} / mois (abonnement
                annuel)
              </span>
            </label>
          </div>
        </div>

        <div className="container text-center mt-4">
          <button
            className="btn"
            style={{
              backgroundColor: "#051259",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
            onClick={handleButtonClick}
          >
            Obtenir ce service
            <FaArrowRight style={{ marginLeft: "8px" }} />
          </button>
        </div>

        {cart.from !== "sales" && (
          <div className="container text-center mt-3">
            <span
              onClick={handleSkipClick}
              style={{ color: "#3392FF", cursor: "pointer" }}
            >
              Pas maintenant, peut-être plus tard.
            </span>
          </div>
        )}

        <GuideSection {...salesGuide} />
      </>
    </div>
  );
}

export default PlatformSale;
